(function () {
  var host = (window.location.hostname || '').toLowerCase();
  var path = window.location.pathname || '/';
  var locale = '';
  if (host === 'footballmasters.cz' || host === 'www.footballmasters.cz' || /^\/cs(\/|$)/i.test(path)) locale = 'cs';
  if (host === 'footballmasters.sk' || host === 'www.footballmasters.sk' || /^\/sk(\/|$)/i.test(path)) locale = 'sk';
  if (host === 'footballmasters.ro' || host === 'www.footballmasters.ro' || /^\/ro-ro(\/|$)/i.test(path)) locale = 'ro';
  if (!locale) return;

  var configs = {
    sk: {
      code: 'SKGK50',
      saleTitle: 'POSEZÓNNY VÝPREDAJ',
      saleLine: 'Všetky brankárske rukavice -50 % do 30. 6. · kód SKGK50',
      cta: 'Nakúpiť so zľavou',
      detail: 'Zľava je aktívna automaticky v košíku cez kód SKGK50.',
      nowLabel: 'Cena po zľave',
      wasLabel: 'Najnižšia cena za posledných 30 dní',
      discountBadge: '-50 %',
      shopPath: '/collections/all'
    },
    ro: {
      code: 'ROGK50',
      saleTitle: 'REDUCERE DE FINAL DE SEZON',
      saleLine: 'Toate mănușile de portar -50 % până la 30.06. · cod ROGK50',
      cta: 'Cumpără cu reducere',
      detail: 'Reducerea este activă automat în coș prin codul ROGK50.',
      nowLabel: 'Preț după reducere',
      wasLabel: 'Cel mai mic preț din ultimele 30 de zile',
      discountBadge: '-50 %',
      shopPath: '/collections/all'
    },
    cs: {
      code: 'CZGK50',
      saleTitle: 'POSEZÓNNÍ VÝPRODEJ',
      saleLine: 'Všechny brankářské rukavice -50 % do 30. 6. · kód CZGK50',
      cta: 'Nakoupit se slevou',
      detail: 'Sleva je aktivní automaticky v košíku přes kód CZGK50.',
      nowLabel: 'Cena po slevě',
      wasLabel: 'Nejnižší cena za posledních 30 dní',
      discountBadge: '-50 %',
      shopPath: '/collections/all'
    }
  };
  var config = configs[locale];

  function injectCss() {
    if (document.getElementById('fm-season-sale-css')) return;
    var style = document.createElement('style');
    style.id = 'fm-season-sale-css';
    style.textContent = [
      '.fm-season-sale-bar{position:relative;z-index:60;background:#101010;color:#fff;border-bottom:1px solid rgba(255,255,255,.14);font-family:inherit}',
      '.fm-season-sale-bar__inner{max-width:1540px;margin:0 auto;padding:10px 16px;display:grid;grid-template-columns:auto 1fr auto;gap:14px;align-items:center}',
      '.fm-season-sale-bar__badge{display:inline-flex;align-items:center;justify-content:center;min-width:72px;border:2px solid #fff;border-radius:4px;padding:4px 9px;font-weight:900;font-size:18px;letter-spacing:0}',
      '.fm-season-sale-bar__copy{display:flex;flex-wrap:wrap;gap:8px 14px;align-items:baseline;min-width:0}',
      '.fm-season-sale-bar__title{font-weight:900;font-size:15px;text-transform:uppercase;letter-spacing:0}',
      '.fm-season-sale-bar__line{font-size:14px;color:rgba(255,255,255,.88)}',
      '.fm-season-sale-bar__cta{display:inline-flex;align-items:center;justify-content:center;min-height:36px;padding:0 14px;background:#fff;color:#111;text-decoration:none;border-radius:4px;font-weight:900;font-size:13px;white-space:nowrap}',
      '.fm-season-sale-panel{margin:18px 0;padding:18px;border:1px solid rgba(255,255,255,.14);background:linear-gradient(135deg,#111,#202020);color:#fff;border-radius:8px}',
      '.fm-season-sale-panel strong{display:block;font-size:clamp(28px,5vw,68px);line-height:.9;letter-spacing:0;text-transform:uppercase}',
      '.fm-season-sale-panel span{display:block;margin-top:8px;font-size:clamp(18px,2.4vw,28px);font-weight:900;text-transform:uppercase}',
      '.fm-season-sale-note{margin-top:8px;color:rgba(255,255,255,.76);font-size:13px}',
      '.fm-season-sale-cart-note{margin:14px 0;padding:12px 14px;border:1px solid rgba(16,16,16,.18);border-radius:6px;background:#f6f6f2;color:#101010;font-weight:800}',
      '.fm-season-sale-cart-note span{display:block;margin-top:3px;font-size:13px;font-weight:600;color:rgba(16,16,16,.72)}',
      '.fm-season-sale-price{display:flex;flex-wrap:wrap;align-items:baseline;gap:8px 12px;margin-top:8px}',
      '.fm-season-sale-price__now{font-weight:900;font-size:1.18em;color:#fff;background:#111;padding:3px 7px;border-radius:4px}',
      '.fm-season-sale-price__was{text-decoration:line-through;color:rgba(255,255,255,.68)}',
      '.fm-season-sale-price__label{font-size:12px;color:rgba(255,255,255,.72)}',
      '.fm-season-sale-card-price{display:grid;gap:3px;margin-top:5px}',
      '.fm-season-sale-card-price .now{font-weight:900}',
      '.fm-season-sale-card-price .was{text-decoration:line-through;opacity:.62;font-size:.86em}',
      '.fm-season-sale-source-price{display:none!important}',
      '@media(max-width:760px){.fm-season-sale-bar__inner{grid-template-columns:1fr;gap:8px;text-align:center}.fm-season-sale-bar__copy{justify-content:center}.fm-season-sale-bar__cta{width:100%}.fm-season-sale-panel{margin:14px 0;padding:16px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function parsePrice(text) {
    var value = String(text || '').replace(/\s+/g, ' ').trim();
    if (!value) return null;
    var isCzk = /Kc|Kč/i.test(value);
    var isEur = /€|EUR/i.test(value);
    var isRon = /lei|RON/i.test(value);
    var match = value.match(/([0-9][0-9\s.,]*)/);
    if (!match) return null;
    var number = match[1].replace(/\s/g, '');
    if (number.indexOf(',') > -1) number = number.replace(/\./g, '').replace(',', '.');
    var amount = Number(number);
    if (!Number.isFinite(amount) || amount <= 0) return null;
    return { amount: amount, currency: isCzk ? 'CZK' : (isEur ? 'EUR' : (isRon ? 'RON' : '')) };
  }

  function formatPrice(amount, currency) {
    if (currency === 'CZK') {
      return amount.toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Kč';
    }
    if (currency === 'EUR') {
      return amount.toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    if (currency === 'RON') {
      return amount.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
    }
    return amount.toFixed(2);
  }

  function installDiscountRedirect() {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('discount') === config.code || url.pathname.indexOf('/discount/') === 0) return;
      if (sessionStorage.getItem('fmSeasonSaleDiscountSet_' + config.code) === '1') return;
      sessionStorage.setItem('fmSeasonSaleDiscountSet_' + config.code, '1');
      var redirect = url.pathname + url.search + url.hash;
      window.location.replace('/discount/' + encodeURIComponent(config.code) + '?redirect=' + encodeURIComponent(redirect));
    } catch (error) {}
  }

  function addTopBar() {
    if (document.querySelector('.fm-season-sale-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'fm-season-sale-bar';
    bar.innerHTML = '<div class="fm-season-sale-bar__inner"><div class="fm-season-sale-bar__badge">' + config.discountBadge + '</div><div class="fm-season-sale-bar__copy"><span class="fm-season-sale-bar__title">' + config.saleTitle + '</span><span class="fm-season-sale-bar__line">' + config.saleLine + '</span></div><a class="fm-season-sale-bar__cta" href="' + config.shopPath + '?discount=' + config.code + '">' + config.cta + '</a></div>';
    document.body.insertBefore(bar, document.body.firstChild);
  }

  function addHomePanel() {
    if (!/^\/(?:cs|sk|ro-ro)?\/?$/i.test(path) && path !== '/') return;
    if (document.querySelector('.fm-season-sale-panel')) return;
    var target = document.querySelector('main, .fm-home, #MainContent') || document.body;
    var panel = document.createElement('section');
    panel.className = 'fm-season-sale-panel';
    panel.innerHTML = '<strong>' + config.discountBadge + '</strong><span>' + config.saleLine + '</span><p class="fm-season-sale-note">' + config.detail + '</p>';
    target.insertBefore(panel, target.firstChild);
  }

  function addCartDiscountNote() {
    if (path.indexOf('/cart') === -1) return;
    if (document.querySelector('.fm-season-sale-cart-note')) return;
    var target = document.querySelector('main, #MainContent, form[action*="/cart"]') || document.body;
    var note = document.createElement('div');
    note.className = 'fm-season-sale-cart-note';
    note.innerHTML = config.discountBadge + ' · ' + config.code + '<span>' + config.detail + '</span>';
    target.insertBefore(note, target.firstChild);
  }

  function priceCandidates(root) {
    root = root || document;
    var selector = [
      '.fm-price',
      '[data-fm-price]',
      '[data-product-price]',
      '[data-price]',
      '.price-item',
      '.price__regular',
      '.price__sale',
      '.product__price',
      '.product-price',
      '.card-information .price',
      '.card__information .price',
      '.price .money',
      '.money'
    ].join(',');
    var nodes = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) nodes.unshift(root);
    return nodes.filter(function (node, index, list) {
      if (!node || node.nodeType !== 1) return false;
      if (list.indexOf(node) !== index) return false;
      if (node.closest('.fm-season-sale-bar,.fm-season-sale-panel,.fm-season-sale-price,.fm-season-sale-card-price')) return false;
      if (node.closest('cart-drawer,cart-notification,.cart,.drawer,.checkout')) return false;
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 90 || text.indexOf('%') !== -1) return false;
      return true;
    });
  }

  function enhancePrices(root) {
    priceCandidates(root).forEach(function (node) {
      if (node.dataset.fmSeasonSaleEnhanced === '1') return;
      var parsed = parsePrice(node.textContent);
      if (!parsed || !parsed.currency) return;
      var sale = parsed.amount / 2;
      node.dataset.fmSeasonSaleEnhanced = '1';
      node.classList.add('fm-season-sale-source-price');
      var wrap = document.createElement('span');
      wrap.className = node.closest('.fm-product-card, .collection-product, article') ? 'fm-season-sale-card-price' : 'fm-season-sale-price';
      wrap.innerHTML = '<span class="fm-season-sale-price__now now">' + config.nowLabel + ': ' + formatPrice(sale, parsed.currency) + '</span><span class="fm-season-sale-price__was was">' + config.wasLabel + ': ' + formatPrice(parsed.amount, parsed.currency) + '</span>';
      node.insertAdjacentElement('afterend', wrap);
    });

    updateCartButtons();
  }

  function primaryVisibleSalePrice() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.fm-season-sale-price__now,.fm-season-sale-card-price .now'));
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      var rect = node.getBoundingClientRect();
      var style = window.getComputedStyle(node);
      if (rect.width <= 0 || rect.height <= 0 || style.display === 'none' || style.visibility === 'hidden') continue;
      var parsed = parsePrice(node.textContent);
      if (parsed && parsed.currency) return parsed;
    }
    return null;
  }

  function updateCartButtons() {
    var salePrice = primaryVisibleSalePrice();
    document.querySelectorAll('[data-add-to-cart], input[type="submit"], button[type="submit"], button[data-fm-sticky-submit], [role="button"]').forEach(function (button) {
      var value = button.value || button.textContent || '';
      if (!/přidat|pridat|pridať|adaug|coș|cos|košíku|košíka|kosika/i.test(value)) return;
      var parsed = salePrice || parsePrice(value);
      if (!parsed || !parsed.currency) return;
      var amount = salePrice ? parsed.amount : parsed.amount / 2;
      var text = value.replace(/·.*$/, '').trim();
      var next = text + ' · ' + formatPrice(amount, parsed.currency);
      if (value.trim() === next) return;
      if (button.value) button.value = next;
      else button.textContent = next;
      button.dataset.fmSeasonSaleButton = '1';
    });
  }

  function tagLinks() {
    document.querySelectorAll('a[href*="/products/"],a[href*="/collections/"],a[href="/"],a[href="/cs/"],a[href="/sk/"],a[href="/ro-ro/"]').forEach(function (link) {
      if (link.dataset.fmSeasonSaleTagged === '1') return;
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('discount', config.code);
        link.href = url.pathname + url.search + url.hash;
        link.dataset.fmSeasonSaleTagged = '1';
      } catch (error) {}
    });
  }

  function init() {
    injectCss();
    addTopBar();
    addHomePanel();
    addCartDiscountNote();
    enhancePrices(document);
    tagLinks();
    installDiscountRedirect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes && mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          addCartDiscountNote();
          enhancePrices(node);
          updateCartButtons();
        }
      });
    });
    tagLinks();
    updateCartButtons();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();